import type { IAPISettings } from '~/types/api';

// This should be our internal slug, e.g. 24-0169-cool-guys-promo
export const getApiURL = (internalPromoSlug: string) => {
	return `https://api.kohub.io/api/v4/promotions/${internalPromoSlug}`;
};

// This only needs to be fetched once per build. To prevent rate limiting we'll just store the value in memory.
let promotionSettings: {
	[slug: string]: IAPISettings;
} = {};

export const getPromotionSettings = async (promotionSlug: string): Promise<IAPISettings> => {
	if (promotionSettings[promotionSlug]) {
		console.log(`getPromotionSettings: Returning cached value`);
		return promotionSettings[promotionSlug];
	}

	const promotionSettingsRequest = await fetch(getApiURL(promotionSlug), {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	});

	if (!promotionSettingsRequest.ok) {
		throw new Error(
			`${promotionSlug} getPromotionSettings: Failed to fetch promotion settings`,
		);
	}

	const response = await promotionSettingsRequest.json();

	promotionSettings[promotionSlug] = response.data;

	return response.data;
};
